import React, { useMemo, useEffect, useState } from "react";
import { Outlet } from "react-router-dom";
import styled from "@emotion/styled";
import { CssBaseline, Grid, useMediaQuery, useTheme } from "@mui/material";

import { ReactComponent as Logo } from "@/vendor/onrounds-logo-symbol-only.svg";

import Settings from "@/components/Settings";
import GlobalStyle from "@/components/GlobalStyle";

// import { fetchApi } from "@/utils/fetchApi";

const Root = styled.div`
  background: ${(props) => props.theme.palette.background.default};
  align-items: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  min-height: 100vh;
`;

const Brand = styled(Logo)`
  fill: ${(props) => props.theme.palette.common.white};
  width: 64px;
  height: 64px;
  position: absolute;
  bottom: 48px;
  left: 48px;
`;

const LeftSide = styled.div`
  background-image: url(${(props) => props.bgImage});
  background-size: cover;
  background-position: center;
  border-radius: 20px;
  position: relative;
  height: calc(100% - ${(props) => props.theme.spacing(8)});
  width: calc(100% - ${(props) => props.theme.spacing(8)});
  margin: ${(props) => props.theme.spacing(4)};
`;

const RightSide = styled.div`
  padding: ${(props) => props.theme.spacing(4)};
  margin: 0 auto;
  justify-content: center;
  align-items: center;
  display: flex;
  min-height: 100%;
  flex-direction: column;
  max-width: 480px;
`;

const AuthCover = ({ children }) => {
  const theme = useTheme();
  const isLargeScreen = useMediaQuery(theme.breakpoints.up("lg"));

  const [logoUrl, setLogoUrl] = useState(null);
  const [splashUrl, setSplashUrl] = useState(null);

  // TODO: Enable when systemSettingValues backend endpoint is deployed
  // useEffect(() => {
  //   const loadAssets = async () => {
  //     try {
  //       const [logoResp, splashResp] = await Promise.all([
  //         fetchApi("systemSettingValues", "getSettingValueByCode", {
  //           code: "company:customization:login:logo",
  //           companyid: 1,
  //         }),
  //         fetchApi("systemSettingValues", "getSettingValueByCode", {
  //           code: "company:customization:login:image",
  //           companyid: 1,
  //         }),
  //       ]);
  //       setLogoUrl(logoResp.rows?.[0]?.SETTINGVALUE ?? null);
  //       setSplashUrl(splashResp.rows?.[0]?.SETTINGVALUE ?? null);
  //     } catch (error) {
  //       console.error("Failed to load branding assets", error);
  //     }
  //   };
  //   loadAssets();
  // }, []);

  const randomImage = useMemo(() => {
    const randomNumber = Math.floor(Math.random() * 5) + 1;
    return `/static/img/unsplash/unsplash-8.jpg`;
  }, []);

  const backgroundImage = splashUrl || randomImage;

  return (
    <Root>
      <CssBaseline />
      <GlobalStyle />
      <Grid container style={{ minHeight: "100vh", width: "100%" }}>
        {isLargeScreen && (
          <Grid item xs={12} lg={7}>
            <LeftSide bgImage={backgroundImage}>
              {logoUrl ? (
                <img
                  src={`https://dev.testlxr.com/uploads/${logoUrl}`}
                  alt="Logo"
                  style={{
                    width: 300,
                    height: 64,
                    position: "absolute",
                    bottom: 48,
                    left: 48,
                  }}
                />
              ) : (
                <Brand />
              )}
            </LeftSide>
          </Grid>
        )}
        <Grid item xs={12} lg={5}>
          <RightSide>
            {children}
            <Outlet />
          </RightSide>
        </Grid>
      </Grid>
    </Root>
  );
};

export default AuthCover;
